export default {
  // Page title
  'page.title': 'Relógio Mundial',

  // Time zones and cities
  'timezone.utc': 'UTC',
  'timezone.local': 'Hora Local',
  'timezone.currentTime': 'Hora Atual',
  'timezone.label': 'Fuso Horário',
  'timezone.title': 'Fuso Horário de {{city}}',
  'timezone.localClockOffset': 'Diferença de Fuso Horário Local',
  'timezone.timeZone': 'Fuso horário',
  'timezone.today': 'Hoje',
  'timezone.hours': 'H',
  'timezone.standardTimeZone': 'Fuso Horário Padrão',
  'timezone.daylightSavingTimeZone': 'Fuso Horário de Verão',

  // City names (keeping English as standard)
  'city.newYork': 'Nova York',
  'city.london': 'Londres',
  'city.paris': 'Paris',
  'city.tokyo': 'Tóquio',
  'city.sydney': 'Sydney',
  'city.dubai': 'Dubai',
  'city.singapore': 'Cingapura',
  'city.hongKong': 'Hong Kong',
  'city.shanghai': 'Xangai',
  'city.beijing': 'Pequim',
  'city.mumbai': 'Mumbai',
  'city.moscow': 'Moscou',
  'city.berlin': 'Berlim',
  'city.losAngeles': 'Los Angeles',
  'city.chicago': 'Chicago',
  'city.toronto': 'Toronto',
  'city.vancouver': 'Vancouver',
  'city.brasilia': 'Brasília',
  'city.buenosAires': 'Buenos Aires',
  'city.cairo': 'Cairo',
  'city.istanbul': 'Istambul',

  // How to use
  'howto.title': 'Como Usar o Relógio Mundial Online',
  'howto.step1': 'Este site de relógio mundial exibe a hora atual e o horário mundial para qualquer cidade do mundo. Consulte fusos horários, diferenças de horário mundial e hora internacional instantaneamente em todo o globo.',
  'howto.step2': 'A página inicial do relógio mundial exibe sua hora local além de vários relógios mundiais para as principais cidades. Cada fuso horário mundial mostra informações precisas de hora, data e diferença de fuso horário.',
  'howto.step3': 'Clique em qualquer nome de cidade na lista do relógio mundial para ver informações detalhadas sobre o fuso horário. Cada página de horário mundial fornece dados abrangentes sobre o fuso horário e a hora atual para aquele local.',
  'howto.step4': 'Use a pesquisa do relógio mundial para encontrar o horário em qualquer cidade do mundo. Perfeito para consultar fusos horários mundiais, coordenação de horário internacional e necessidades de gestão de tempo global.',

  // User reviews
  'reviews.title': 'Avaliações dos Usuários',
  'reviews.globalBusiness': 'Essencial para negócios internacionais! Facilita a coordenação de horários de reuniões entre diferentes fusos horários, muito conveniente.',
  'reviews.travelBlogger': 'Indispensável para planejamento de viagens! Sempre sei o horário local do meu destino, sem mais confusão com o jet lag.',
  'reviews.remoteTeam': 'Perfeito para colaboração de equipes remotas! Fácil de ver quando colegas em diferentes países estão trabalhando.',
  'reviews.internationalFamily': 'Ótimo para manter contato com família no exterior! Sempre sei o melhor horário para ligar sem atrapalhar o sono deles.',
  'reviews.managerZhang': 'Como gerente de projetos, isso me ajuda a agendar reuniões com clientes globais de forma mais eficaz.',

  // User names
  'user.globalBusiness': 'Negócios Globais',
  'user.travelBlogger': 'Blogueiro de Viagens',
  'user.remoteTeam': 'Desenvolvedor Remoto',
  'user.internationalFamily': 'Família Internacional',
  'user.managerZhang': 'Gerente Zhang',

  // Keywords
  'keywords.worldclock': 'relógio mundial fusos horários hora internacional que horas são',
  'keywords.chinese': '世界时钟 时区 国际时间 现在几点',
  'keywords.japanese': '世界時計 タイムゾーン 国際時間 今何時',
  'keywords.spanish': 'reloj mundial zonas horarias tiempo internacional qué hora',
  'keywords.german': 'Weltzeituhr Zeitzonen internationale Zeit wie spät',
  'keywords.french': 'horloge mondiale fuseaux horaires temps international quelle heure',
  'keywords.russian': 'мировые часы часовые пояса международное время который час',

  // Country related
  'countriesTime': 'Hora por País',
  'timeIn': 'Hora em',
  'cities': 'cidades',
  'available': 'disponíveis',
  'citiesIn': 'Cidades em',
  'viewDetails': 'Ver detalhes',
  'countryNotFound': 'País não encontrado',
  'backToWorldClock': 'Voltar ao Relógio Mundial',
  'cityNotFound': 'Cidade não encontrada',
  'popularCitiesIn': 'Cidades Populares em',
  'currentTime': 'Hora Atual',
};
